import { render } from "./YourCampaignTab.vue?vue&type=template&id=5e5281e6&scoped=true"
import script from "./YourCampaignTab.vue?vue&type=script&lang=js"
export * from "./YourCampaignTab.vue?vue&type=script&lang=js"

import "./YourCampaignTab.vue?vue&type=style&index=0&id=5e5281e6&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5281e6"]])

export default __exports__